var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3459 0C17.6501 0 0 17.8044 0 39.5002C0 45.9599 1.59343 52.3383 4.61304 58.0001L1.43065 74.7077C1.28823 75.4604 1.52554 76.2356 2.06805 76.7781C2.61056 77.3206 3.38576 77.5533 4.13842 77.4155L20.8459 74.2331C26.5077 77.2527 32.8861 79.0002 39.3458 79.0002C61.0416 79.0002 78.846 61.1962 78.846 39.5004C78.846 17.8046 61.0417 0 39.3459 0V0Z",
    fill: "url(#paint0_linear_24_33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6751 50.7087C63.3134 48.4779 61.9484 46.62 59.9277 45.6097L52.5774 41.9346C51.6846 41.4848 50.6066 41.6589 49.9059 42.3686L47.1393 45.1374C45.9708 45.2187 42.7454 45.0266 38.451 40.7322C34.1543 36.4377 33.9486 33.201 34.0458 32.0438L36.8145 29.2772C37.5196 28.5743 37.6937 27.4962 37.2485 26.6057L33.5735 19.2554C32.5631 17.2371 30.7075 15.8697 28.4789 15.508C26.2345 15.1554 24.051 15.8538 22.4531 17.4519L18.3937 21.5113C17.0488 22.8561 16.3256 24.6553 16.3549 26.5832C16.4318 31.0245 18.1269 40.0474 28.6302 50.5529C38.1594 60.082 47.5461 62.2021 52.297 62.6179C54.3319 62.7967 56.3722 62.0893 57.8504 60.6086L61.7311 56.7301C63.3293 55.132 64.0368 52.9373 63.6751 50.7087Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_33",
    x1: 39.4231,
    y1: 79,
    x2: 39.4231,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2B452"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.471b94e1b159af652b49f966cda4f686.svg";
export { ForwardRef as ReactComponent };